import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Colors } from 'copyright-clearance-center-common-ui';
import { PanelResizeHandle } from 'react-resizable-panels';

const HandleDot = styled(Box)({
	borderRadius: '2px',
	height: '0.25rem',
	borderRight: `solid 4px ${Colors.neutral500}`
});

const StyledResizeHandle = styled(PanelResizeHandle)({
	display: 'flex',
	width: '10px',
	borderLeft: `solid 1px ${Colors.neutral300}`,
	justifyContent: 'center',
	':hover,:focus': {
		borderRight: `solid 1px ${Colors.neutral300}`
	},
	position: 'relative'
});

const StyledResizeHandleInner = styled('div')({
	position: 'absolute',
	display: 'flex',
	gap: '0.125rem',
	flexDirection: 'column',
	top: '50%',
	transform: 'translate(0, -50%)',
	left: '2px'
});

const ResizeHandle: React.FunctionComponent = () => {
	const dotsCount = 3;

	return (
		<StyledResizeHandle>
			<StyledResizeHandleInner>
				{[...Array(dotsCount)].map((_, i) => (
					<HandleDot key={i} />
				))}
			</StyledResizeHandleInner>
		</StyledResizeHandle>
	);
};

export default ResizeHandle;
